import { commonMessages } from '../../../../util/messages'

export const messages = {
  common: commonMessages,
  ratings: {
    update: {
      error: 'There is a problem creating banking rating',
      success: 'Banking group rating created successfully',
    },
  },
}
